"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AGORA_ENCODER_CONFIG = void 0;
var AGORA_ENCODER_CONFIG = exports.AGORA_ENCODER_CONFIG = '720p_2';